import { useEffect } from "react";

import { useIsLgOrLarger } from "mds/hooks/use-responsive";
import { useQueryParam, useQueryParamsActions } from "utils/routing";

export const useFindItemBySearchParamId = <T extends { id: string }>(
  items: T[],
  searchParam: string,
  shouldDefaultFirstEvenOnSmallScreen: boolean = false,
) => {
  const shouldDefaultFirst = useIsLgOrLarger() || shouldDefaultFirstEvenOnSmallScreen;

  const { setQueryParams } = useQueryParamsActions();
  const itemId = useQueryParam(searchParam);

  useEffect(() => {
    if (shouldDefaultFirst && itemId === null && items.length > 0 && items[0].id) {
      setQueryParams({ [searchParam]: items[0].id });
    }
  }, [shouldDefaultFirst, itemId, items, searchParam, setQueryParams]);

  if (items.length === 0) {
    return undefined;
  }

  return items.find((item) => item.id === itemId);
};
